export default [{
        Scene: '管理模式',
        SceneName: undefined,
        SceneConfig: undefined,
        Role: 'Manager',
        OrgRole: '',
        Layout: 'Template_Admin_1',
        SubTitle: '管理中心',
        Page: [{
            Page: '首页',
            ParentPage: undefined,
            Name: 'home',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '企业',
            ParentPage: undefined,
            Name: 'company',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '学员',
            ParentPage: undefined,
            Name: 'student',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '培训',
            ParentPage: undefined,
            Name: 'training',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '安全',
            ParentPage: undefined,
            Name: 'safe',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '题库',
            ParentPage: undefined,
            Name: 'libray',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '课件',
            ParentPage: undefined,
            Name: 'lesson',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '试卷',
            ParentPage: undefined,
            Name: 'paper',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '考试',
            ParentPage: undefined,
            Name: 'exam',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '一周事故',
            ParentPage: undefined,
            Name: 'news',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '曝光台',
            ParentPage: undefined,
            Name: 'bao',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '设置',
            ParentPage: undefined,
            Name: 'setting',
            Title: '',
            Type: '首页',
            Entity: '',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'ViewPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'ViewPanel0',
                Theme: '',
                Comp: '面板'
            }]
        },
        {
            Page: '学员详情',
            ParentPage: undefined,
            Name: 'users_detail',
            Title: '',
            Type: '详情',
            Entity: 'Users',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                },
                {
                    Name: 'DataPanel1'
                },
                {
                    Name: 'DataScrollList2'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            },
            {
                Name: 'DataPanel1',
                Theme: '',
                Comp: '数量统计'
            },
            {
                Name: 'DataScrollList2',
                Theme: '数据分页列表',
                Comp: '数据列表'
            }]
        },
        {
            Page: '企业详情',
            ParentPage: undefined,
            Name: 'company_detial',
            Title: '',
            Type: '详情',
            Entity: 'Company',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                },
                {
                    Name: 'DataPanel1'
                },
                {
                    Name: 'DataScrollList2'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            },
            {
                Name: 'DataPanel1',
                Theme: '',
                Comp: '数量统计'
            },
            {
                Name: 'DataScrollList2',
                Theme: '数据分页列表',
                Comp: '数据列表'
            }]
        },
        {
            Page: '培训详情',
            ParentPage: undefined,
            Name: 'training_detail',
            Title: '',
            Type: '详情',
            Entity: 'Training',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                },
                {
                    Name: 'DataScrollList1'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            },
            {
                Name: 'DataScrollList1',
                Theme: '数据分页列表',
                Comp: '数据列表'
            }]
        },
        {
            Page: '题库详情',
            ParentPage: undefined,
            Name: 'libray_detail',
            Title: '',
            Type: '详情',
            Entity: 'Library',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            }]
        },
        {
            Page: '培训详情',
            ParentPage: undefined,
            Name: 'training_detail',
            Title: '',
            Type: '详情',
            Entity: 'Training',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                },
                {
                    Name: 'DataScrollList1'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            },
            {
                Name: 'DataScrollList1',
                Theme: '数据分页列表',
                Comp: '数据列表'
            }]
        },
        {
            Page: '试卷详情',
            ParentPage: undefined,
            Name: 'paper_detail',
            Title: '',
            Type: '详情',
            Entity: 'Paper',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            }]
        },
        {
            Page: '题目详情',
            ParentPage: undefined,
            Name: 'topic_detial',
            Title: '',
            Type: '详情',
            Entity: 'Paper.Topic',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            }]
        },
        {
            Page: '考试详情',
            ParentPage: undefined,
            Name: 'exam_detail',
            Title: '',
            Type: '详情',
            Entity: 'Exam',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            }]
        },
        {
            Page: '培训课件详情',
            ParentPage: undefined,
            Name: 'training_video_detail',
            Title: '',
            Type: '详情',
            Entity: 'Training.Lessons',
            RoleFields: '',
            FullScreen: undefined,
            BackgroundColor: undefined,
            ColumnSpan: undefined,
            Layout: {
                Type: 'Flex',
                H: false,
                Columns: [{
                    Name: 'DetailPanel0'
                },
                {
                    Name: 'DataScrollList1'
                }]
            },
            Config: {
                Border: {
                    Span: 0,
                    BC: '#fff'
                }
            },
            Columns: [{
                Name: 'DetailPanel0',
                Theme: '',
                Comp: '视图面板'
            },
            {
                Name: 'DataScrollList1',
                Theme: '数据分页列表',
                Comp: '数据列表'
            }]
        }]
    }]